/**
 * This class extends RaceContestantDetails to add some more fields that we can choose what values we want to import if there is conflicts
 */

import { ContestantBase, RaceContestantDetails } from './generated';

export class RaceContestantDetailsExternalData {
    public RaceContestantDetails: RaceContestantDetails;
    public RegisteredClubID: number | null = null;
    public RegisteredCategoryID: number | null = null;
    public RegisteredRaceID: number | null = null;
    public RegisteredEMITID: string | null = null;

    public EMITID: string | null = null;

    public RegisteredEMITIDs: string | null = null;

    // Helper property to show the category name instead of having to look it up in the category list
    public RegisteredCategoryName: string | null = null;

    // The name of the race from the source data
    public RegisteredRaceName: string | null = null;

    public UseExternalCategory: boolean = true;
    public UseExternalClub: boolean = true;
    public UseExternalEMITID: boolean = true;
    public UseExternalRace: boolean = true;
    public UseExternalRelayContestants: boolean = true;

    // Contains a translationkey for the current error message that denies the import
    public ErrorMessage: string | null = null;

    constructor(rc?: RaceContestantDetails) {
        if (rc) {
            this.RaceContestantDetails = rc;
        } else {
            this.RaceContestantDetails = RaceContestantDetails.FromJsValues({});
        }
    }

    /**
     * Will convert to a RaceContestantDetails object, applying the correct values based on what the user has chosen to import
     * @returns
     */
    public ToRaceContestantDetails(): RaceContestantDetails {
        // We need to map in the correct new values

        if (!this.UseExternalCategory) {
            this.RaceContestantDetails.CategoryName = this.RegisteredCategoryName;
            // TODO: Why are we changing the CategoryName, but not the ID?
        }

        if (!this.UseExternalClub) {
            this.RaceContestantDetails.ClubID = this.RegisteredClubID;
        }

        if (!this.UseExternalEMITID) {
            // TODO: We need to map in the correct EMITID here
        }
        if (!this.UseExternalRace) {
            this.RaceContestantDetails.RaceName = this.RegisteredRaceName;
            // TODO: We should set the raceID (?)
        }

        return this.RaceContestantDetails;
    }

    public static FromContestantBase(cb: ContestantBase): RaceContestantDetailsExternalData {
        const raceContestantDetails = RaceContestantDetails.FromJsValues({
            ISonenID: cb.ISonenID,
            GPSDeviceID: cb.GPSDeviceID,
            NationalityCountryID: cb.NationalityCountryID,
            ParticipantID: cb.ParticipantID,
            Bib: cb.Bib,
            Birthday: cb.Birthday,
            CategoryID: cb.CategoryID,
            ClubID: cb.ClubID,
            ContestantStatusID: cb.ContestantStatusID,
            EntityState: 'Unchanged',
            EventID: cb.EventID,
            EventTeamId: cb.EventTeamId,
            Firstname: cb.Firstname,
            Surname: cb.Surname,
            TeamID: cb.TeamID,
            RaceContestants: cb.RaceContestants.map((rc) => rc.DeepClone()),
        });

        return new RaceContestantDetailsExternalData(raceContestantDetails);
    }

    public static FromRaceContestantDetails(rc: RaceContestantDetails): RaceContestantDetailsExternalData {
        return new RaceContestantDetailsExternalData(rc);
    }
}
